var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "10px",
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-771.000000, -1544.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(736.000000, 1316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2067328,8.49061222 C19.3110279,8.14260066 19.2067328,7.888889 18.705663,7.888889 L17.0528127,7.888889 C16.6333651,7.888889 16.4383786,8.10892212 16.3340836,8.35140759 C16.3340836,8.35140759 15.4929211,10.3811008 14.3025968,11.6990543 C13.9171584,12.0807444 13.7425775,12.2019871 13.5317201,12.2019871 C13.427425,12.2019871 13.275517,12.0807444 13.275517,11.7327328 L13.275517,8.49061222 C13.275517,8.07524358 13.1530836,7.888889 12.8039218,7.888889 L10.205614,7.888889 C9.94260898,7.888889 9.78389908,8.08197929 9.78389908,8.26608863 C9.78389908,8.66125015 10.3801949,8.75105958 10.4414115,9.86245135 L10.4414115,12.2738347 C10.4414115,12.8014651 10.3439183,12.8980103 10.1353282,12.8980103 C9.57530892,12.8980103 8.21267103,10.8593361 7.40325052,8.52653599 C7.24454061,8.07299834 7.08583071,7.89113424 6.66411582,7.89113424 L5.01126553,7.89113424 C4.53967039,7.89113424 4.44444444,8.11116735 4.44444444,8.35365283 C4.44444444,8.78698336 5.00446368,10.9379193 7.05408873,13.7826332 C8.42126119,15.7247623 10.3439183,16.7777779 12.0965291,16.7777779 C13.1462818,16.7777779 13.2777843,16.5442734 13.2777843,16.1401309 L13.2777843,14.6717466 C13.2777843,14.2047376 13.3775448,14.1104377 13.7108356,14.1104377 C13.9557023,14.1104377 14.3774172,14.2316804 15.356884,15.1679438 C16.4769225,16.2770903 16.6628398,16.7755327 17.2931448,16.7755327 L18.9459951,16.7755327 C19.4175903,16.7755327 19.6533878,16.5420281 19.5173508,16.0795095 C19.36771,15.6192362 18.8326309,14.9524011 18.1229709,14.1598328 C17.7375326,13.7085404 17.1593751,13.2235695 16.9847942,12.981084 C16.7399275,12.6689962 16.8102133,12.5297916 16.9847942,12.2536276 C16.9825269,12.2536276 18.9958754,9.44483747 19.2067328,8.49061222 Z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default ForwardRef;